import { useGateValue } from '@statsig/react-bindings';

export default function useIsSteloEnabled() {
  return useGateValue('dexcom_rollout');
}
